import { Injectable } from '@angular/core';
import { NestAuthProvider } from '../../../shared/nestjs/nest-auth';
import { Storage } from '@ionic/storage';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { Platform } from 'ionic-angular';
import { BackgroundGeolocationNative } from '../../../native/background-geolocation.native';
import { TrackerApi } from '../../../shared/nestjs/gd-only/services/tracker.api';
import { AlertServiceProvider } from '../../../providers/alert-service/alert-service';
import { AppPreferences } from '../../../shared/local/app-preferences.local';
import { AppVersion } from '@ionic-native/app-version';
import { GlobalServiceProvider } from '../../../providers/global-service/global-service';
import { Messages } from '../../../helpers/messages';
@Injectable()
export class BackgroundGeolocationBloc {

  constructor(
    private nestAuthProvider: NestAuthProvider,
    private storage: Storage,
    private nestApiProvider: NestApiProvider,
    private platform: Platform,
    private backgroundGeolocationNative: BackgroundGeolocationNative,
    private trackerApi: TrackerApi,
    private alertServiceProvider: AlertServiceProvider,
    private appPreferences: AppPreferences,
    private appVersion: AppVersion,
    private globalService: GlobalServiceProvider
  ) {
  }

  public async initBackGroundLocation(): Promise<void> {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova')) {
        const SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
        if (SFGoAuth.menu['tracking']) {
          const settings = await this.appPreferences.getSettings();
          const interval = (settings.intervalTracker) ? settings.intervalTracker * 60 * 1000 : 15 * 60 * 1000;

          const name = await this.appVersion.getVersionNumber();
          const code = await this.appVersion.getVersionCode();
          const versionApps = `ver. ${name} - ${code}`;

          const config = {
            startForeground: true,
            stationaryRadius: 20,
            distanceFilter: 30,
            debug: false,
            stopOnTerminate: true,
            interval,
            fastestInterval: interval,
            stopOnStillActivity: false,
            notificationTitle: `GreatDay ${versionApps}`,
            notificationText: `Tracking ${SFGoAuth.fullName}`,
            url: this.nestApiProvider.urlBuilder('POST', 'newTracker', 'log', {}, {}, ''),
            httpHeaders: {
              'Authorization': this.nestAuthProvider.getAccessToken(),
              ...(this.platform.is('android') && { 'Content-Type': 'application/json' }),
            },
            postTemplate: {
              empId: SFGoAuth.empId,
              location: {
                latitude: '@latitude',
                longitude: '@longitude',
              },
            }
          };

          await this.backgroundGeolocationNative.configure(config);

          try {
            const status = await this.trackerApi.status().toPromise();
            const checkStatus = await this.backgroundGeolocationNative.checkStatus();
            if (status.data.trackingStatus && !(checkStatus.isRunning)) {
              const canStart = await this.canStart();
              if (canStart) {
                await this.backgroundGeolocationNative.configure(config);
                await this.backgroundGeolocationNative.start();
              }
            }
            return Promise.resolve();
          } catch (e) {
            return Promise.resolve();
          }
        } else {
          return Promise.resolve();
        }
      } else {
        return Promise.resolve();
      }
    } catch (error) {
      return Promise.resolve();
    }
  }

  public async canStart(): Promise<boolean> {
    try {
      const SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
      if (SFGoAuth.menu['tracking']) {

        if (this.platform.is('android')) {
          const isGooglePlayServicesAvailable: boolean = this.globalService.getIsGooglePlayServicesAvailable();
          const isGoogleMapsAvailable: boolean = this.globalService.getIsGoogleMapsAvailable();
          if (!isGooglePlayServicesAvailable || !isGoogleMapsAvailable) {
            this.alertServiceProvider.createMola(Messages.TRACKING_NOT_SUPPORT);
            return false;
          }
        }

        const checkStatus = await this.backgroundGeolocationNative.checkStatus();
        if (!checkStatus.locationServicesEnabled) {
          this.alertServiceProvider.createMola('Please turn on location services.').then(() => {
            this.backgroundGeolocationNative.showLocationSettings();
            return false
          })
        } else if (checkStatus.authorization === this.backgroundGeolocationNative.plugin().NOT_AUTHORIZED) {
          this.alertServiceProvider.createMola('Please Allow this application to use location services.').then(() => {
            this.backgroundGeolocationNative.showAppSettings();
            return false;
          })
        } else {
          return true;
        }
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  async checkIsRunning(): Promise<void> {
    try {
      if (this.platform.is('cordova')) {
        const SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
        if (SFGoAuth.menu['tracking']) {
          const status = await this.trackerApi.status().toPromise();
          if (!status.data.trackingStatus) {
            this.backgroundGeolocationNative.stop();
          }
        } else {
          this.backgroundGeolocationNative.stop();
        }
      }
      return Promise.resolve();
    } catch (e) {
      try {
        this.backgroundGeolocationNative.stop();
      } catch (error) { }
      return Promise.resolve();
    }
  }

  async checkStatus() {
    const checkStatus = await this.backgroundGeolocationNative.checkStatus();
    return (checkStatus.isRunning) ? true : false;
  }

}



// WEBPACK FOOTER //
// ./src/bloc/feature/background-geolocation/background-geolocation.bloc.ts